var map = {
	"./Auth/Login": 9011,
	"./Auth/Login.vue": 9011,
	"./BatchSales/Create": 9071,
	"./BatchSales/Create.vue": 9071,
	"./BatchSales/Edit": 8479,
	"./BatchSales/Edit.vue": 8479,
	"./BatchSales/Index": 9912,
	"./BatchSales/Index.vue": 9912,
	"./Batches/Create": 9661,
	"./Batches/Create.vue": 9661,
	"./Batches/Edit": 3163,
	"./Batches/Edit.vue": 3163,
	"./Batches/Index": 9300,
	"./Batches/Index.vue": 9300,
	"./Cart/Index": 4445,
	"./Cart/Index.vue": 4445,
	"./Contacts/Create": 9363,
	"./Contacts/Create.vue": 9363,
	"./Contacts/Edit": 7733,
	"./Contacts/Edit.vue": 7733,
	"./Contacts/Index": 2834,
	"./Contacts/Index.vue": 2834,
	"./Customers/Create": 2607,
	"./Customers/Create.vue": 2607,
	"./Customers/Edit": 6563,
	"./Customers/Edit.vue": 6563,
	"./Customers/Index": 8324,
	"./Customers/Index.vue": 8324,
	"./Dashboard/Index": 1019,
	"./Dashboard/Index.vue": 1019,
	"./Discharges/Create": 5594,
	"./Discharges/Create.vue": 5594,
	"./Discharges/Edit": 5093,
	"./Discharges/Edit.vue": 5093,
	"./Discharges/Index": 8445,
	"./Discharges/Index.vue": 8445,
	"./DiscountedLoadingProducts/Create": 4832,
	"./DiscountedLoadingProducts/Create.vue": 4832,
	"./Home/Coupon": 2415,
	"./Home/Coupon.vue": 2415,
	"./Home/DeleteUser": 8626,
	"./Home/DeleteUser.vue": 8626,
	"./Home/Index": 7307,
	"./Home/Index.vue": 7307,
	"./Home/Participate": 3225,
	"./Home/Participate.vue": 3225,
	"./Home/Privacy-policy": 1304,
	"./Home/Privacy-policy.vue": 1304,
	"./Home/Social": 8067,
	"./Home/Social.vue": 8067,
	"./Home/SocialSpain": 9944,
	"./Home/SocialSpain.vue": 9944,
	"./Home/Stores": 4093,
	"./Home/Stores.vue": 4093,
	"./Home/TerminiCondizioni": 1163,
	"./Home/TerminiCondizioni.vue": 1163,
	"./Home/Whatsapp": 6369,
	"./Home/Whatsapp.vue": 6369,
	"./Join/Done": 7269,
	"./Join/Done.vue": 7269,
	"./Join/SaveContact": 1885,
	"./Join/SaveContact.vue": 1885,
	"./Join/SelectStore": 4599,
	"./Join/SelectStore.vue": 4599,
	"./Join/SendMessage": 5816,
	"./Join/SendMessage.vue": 5816,
	"./LoadingProducts/Create": 3883,
	"./LoadingProducts/Create.vue": 3883,
	"./Organizations/Create": 2120,
	"./Organizations/Create.vue": 2120,
	"./Organizations/Edit": 2773,
	"./Organizations/Edit.vue": 2773,
	"./Organizations/Index": 1808,
	"./Organizations/Index.vue": 1808,
	"./Products/Create": 4663,
	"./Products/Create.vue": 4663,
	"./Products/Edit": 7487,
	"./Products/Edit.vue": 7487,
	"./Products/EditPrice": 1308,
	"./Products/EditPrice.vue": 1308,
	"./Products/Import": 5720,
	"./Products/Import.vue": 5720,
	"./Products/Index": 2995,
	"./Products/Index.vue": 2995,
	"./Products/SearchProduct": 1369,
	"./Products/SearchProduct.vue": 1369,
	"./Reports/Index": 3223,
	"./Reports/Index.vue": 3223,
	"./Sales/Create": 3938,
	"./Sales/Create.vue": 3938,
	"./Sales/Edit": 4833,
	"./Sales/Edit.vue": 4833,
	"./Sales/Index": 569,
	"./Sales/Index.vue": 569,
	"./Users/Create": 3704,
	"./Users/Create.vue": 3704,
	"./Users/Edit": 6046,
	"./Users/Edit.vue": 6046,
	"./Users/Index": 2466,
	"./Users/Index.vue": 2466
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3218;